import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import NotificationToast from './NotificationToast';
import './NotificationContainer.scss';

const NotificationContainer: React.FC = () => {
  const { notifications, clearNotifications } = useNotifications();

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="notification-container">
      <div className="notification-container__header">
        <h3>Notificações ({notifications.length})</h3>
        <button
          className="notification-container__clear"
          onClick={clearNotifications}
          aria-label="Limpar todas as notificações"
        >
          Limpar todas
        </button>
      </div>
      
      <div className="notification-container__list">
        {notifications.map(notification => (
          <NotificationToast
            key={notification.id}
            notification={notification}
          />
        ))}
      </div>
    </div>
  );
};

export default NotificationContainer; 